export function normalizeCellRange(anchor, end) {
  if (!anchor || !end) return null;

  return {
    minRow: Math.min(anchor.rowIndex, end.rowIndex),
    maxRow: Math.max(anchor.rowIndex, end.rowIndex),
    minField: Math.min(anchor.fieldIndex, end.fieldIndex),
    maxField: Math.max(anchor.fieldIndex, end.fieldIndex),
  };
}

export function isCellInRange(range, rowIndex, fieldIndex) {
  if (!range) return false;

  return (
    rowIndex >= range.minRow &&
    rowIndex <= range.maxRow &&
    fieldIndex >= range.minField &&
    fieldIndex <= range.maxField
  );
}

export function getCellRangeEdges(range, rowIndex, fieldIndex) {
  if (!isCellInRange(range, rowIndex, fieldIndex)) return null;

  return {
    top: rowIndex === range.minRow,
    bottom: rowIndex === range.maxRow,
    left: fieldIndex === range.minField,
    right: fieldIndex === range.maxField,
  };
}

export function getSelectedFileIndicesFromRange(range, toFileIndex) {
  const rows = new Set();
  if (!range) return rows;

  for (let rowIndex = range.minRow; rowIndex <= range.maxRow; rowIndex += 1) {
    const fileIndex = toFileIndex(rowIndex);
    if (fileIndex >= 0) {
      rows.add(fileIndex);
    }
  }

  return rows;
}
